import { render, staticRenderFns } from "./sales-order-summary.vue?vue&type=template&id=edd47d56&scoped=true"
import script from "./sales-order-summary.vue?vue&type=script&lang=js"
export * from "./sales-order-summary.vue?vue&type=script&lang=js"
import style0 from "./sales-order-summary.vue?vue&type=style&index=0&id=edd47d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd47d56",
  null
  
)

export default component.exports